import { BaseReq, PaginationReq, PaginationResp, UpdaterResp, FileRecord } from "@/core/interface";
import { getCurrentUserId } from "@/utils";
import { QuantityRecord } from "./form/quantity-table/quantity-table.interface";
import { MaterialRecord } from "./form/material-table/material-table.interface";
/**
 * Tab 枚举
 */
export enum VisaTabEnum {
  BASIC_TAB = "BASIC_TAB", // 基本信息
  QUANTITY_TAB = "QUANTITY_TAB", // 工程量清单
  MATERIAL_TAB = "MATERIAL_TAB", // 材料清单
  ATTACHMENT_TAB = "ATTACHMENT_TAB", // 附件
  FLOW_TAB = "FLOW_TAB", // 流程
}

export class VisaReq extends BaseReq {
  projectId: string | undefined = undefined; // 项目ID
  projectName: string | undefined = undefined; // 项目ID
  contractId: string | undefined = undefined; // 合同ID
  contractName: string | undefined = undefined; // 合同ID
  agentUserId: string = getCurrentUserId(); // 经办人ID
  visaDate: string = ""; // 签证日期
  visaType: string | undefined = undefined; // 签证类型
  offlineVisaNo: string = ""; // 线下签证单编号
  visaAmount: number = 0; // 本次签证金额
  displayVisaAmount: number = 0; // 本次签证金额
  contractAmount: number = 0; // 合同初始金额
  displayContractAmount: number = 0; // 合同初始金额
  totalVisaAmount: number = 0; // 累计签证金额
  displayTotalVisaAmount: number = 0; // 累计签证金额
  changeParts: string = ""; // 变更部位
  content: string = ""; // 签证内容
  reason: string = ""; // 变更原因
  fileList: FileRecord[] = []; //附件
  quantitiesList: QuantityRecord[] = [];
  materialList: MaterialRecord[] = [];
}

export class VisaPageReq extends PaginationReq {
  projectId: string | undefined = undefined; // 项目ID
  bizNo: string | undefined = undefined; // 签证编号
  projectName: string | undefined = undefined; // 项目名称
  contractName: string | undefined = undefined; // 合同名称
  visaType: string | undefined = undefined; // 签证类型
  agentUserId: string | undefined = undefined; // 经办人ID
  validStatus: string | undefined = undefined; // 生效状态
  flowStatus: string | undefined = undefined; // 审批状态
  visaBizNo: string | undefined = undefined; // 签证编号

}

export class VisaListRecord extends UpdaterResp {
  id: string = ""; // 签证ID
  bizNo: string = ""; // 签证编号
  contractName: string = ""; // 关联合同名称
  projectName: string = ""; // 项目名称
  visaTypeValue: string = ""; // 签证类型
  visaDate: string = ""; // 签证日期
  visaAmount: number = 0; // 签证金额
  agentUserName: string = ""; // 经办人名称
  validStatusName: string = ""; // 生效状态
  flowStatusName: string = ""; // 审批状态
  lastModifiedTime: string = ""; // 更新时间
}

export class VisaPageResp extends PaginationResp<VisaListRecord> {}

export class VisaDetailResp extends UpdaterResp {
  projectId: string = ""; // 项目ID
  projectName: string = ""; // 项目名称
  contractId: string = ""; // 合同ID
  contractName: string = ""; // 合同名称
  agentUserId: string = ""; // 经办人ID
  agentUserName: string = ""; // 经办人名称
  visaDate: string = ""; // 签证日期
  visaType: string = ""; // 签证类型
  visaTypeValue: string = ""; // 签证类型显示值
  offlineVisaNo: string = ""; // 线下签证单编号
  visaAmount: number = 0; // 本次签证金额
  contractAmount: number = 0; // 合同初始金额
  totalVisaAmount: number = 0; // 累计签证金额
  changeParts: string = ""; // 变更部位
  content: string = ""; // 签证内容
  reason: string = ""; // 变更原因
  flowStatus: string = ""; // 审批状态
  flowStatusName: string = ""; // 审批状态显示值
  validStatus: string = ""; // 生效状态
  validStatusName: string = ""; // 生效状态显示值
  materialList: MaterialRecord[] = []; // 材料清单
  quantitiesList: QuantityRecord[] = []; // 工程量清单
}
